import { render, staticRenderFns } from "./PgWidgetLoaded.vue?vue&type=template&id=787b693e"
import script from "./PgWidgetLoaded.vue?vue&type=script&lang=js"
export * from "./PgWidgetLoaded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports